module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "calltoaction",
    attrs: {
      "id": "download"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Подписка")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("\n                Проект на стадии разработки. "), _c('br'), _vm._v("\n                Мы можем вас уведомить, "), _c('br'), _vm._v("\n                когда будут запущены тестовые релизы\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "r1 row"
  }, [_c('div', {
    staticClass: "c1 col-md-12"
  }, [_c('div', {
    staticClass: "newsletter-wrapper animateblock rtl-2 speed-1"
  }, [_c('h3', [_vm._v("Заинтересовало? "), _c('br'), _vm._v("\n                        Подпишись на уведомления:")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline subscription-mailchimp"
  }, [_c('div', {
    staticClass: "form-group input-group input-newsletter"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "newsletter-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "newsletter-email",
      "type": "email",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Подписаться")])])]), _vm._v(" "), _c('small', {
    staticClass: "help-block"
  }, [_vm._v("Обещаем не спамить. Только важное")])]), _vm._v(" "), _c('div', {
    staticClass: "alerts alerts-newsletter"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bcf77ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CallToAction.vue
// module id = 1232
// module chunks = 1